export const INITIALISE_STATIC_DATA = 'candidateExperience/INITIALISE_STATIC_DATA'
export const INITIALISE_CURRENT_USER = 'candidateExperience/INITIALISE_CURRENT_USER'

// Generate our action creators since they are all very similar
const createActionCreator = typeName => initialState => ({
  type: typeName,
  payload: initialState,
})

export const initialiseStaticData = createActionCreator(INITIALISE_STATIC_DATA)
export const initialiseCurrentUser = createActionCreator(INITIALISE_CURRENT_USER)

// Generate our reducers since they are all very similar
const createReducer =
  typeName =>
  (state = {}, { type, payload }) => {
    switch (type) {
      case typeName:
        return {
          ...state,
          ...payload,
        }

      default:
        return state
    }
  }

export const staticDataReducer = createReducer(INITIALISE_STATIC_DATA)
export const currentUserReducer = createReducer(INITIALISE_CURRENT_USER)
